export default __webpack_public_path__ + "static/media/velo_layout.494b390f.png";